const templates =  {
    "shop.okraina.ru": {
        title: "История push уведомлений",
        tags: [

        ]
    },
    "dostavka.okraina.ru": {
        title: "История push уведомлений",
        tags: [

        ]
    },
}

export default templates;